import React, {ReactNode} from 'react';
import {Dialog} from "@headlessui/react";
import {CloseIcon} from "../icons";
import clsx from "clsx";

const ModalRequest = ({ open, onClose, title, children, className }:
  { open: boolean; onClose: () => void; title?: string; children?: ReactNode, className?: string }
) => {

  return (
    <Dialog open={open} onClose={onClose} className="fixed inset-0 overflow-y-auto z-20">
      <div className="bg-darkGray/50 bg-center bg-no-repeat text-white w-full h-full absolute inset-0 p-3 z-20">

        <div className="relative z-10 flex items-center justify-center h-full flex-col" >
          <div className="absolute z-10 inset-0" onClick={onClose}/>
          <div className={
            clsx(
              "relative z-30 p-5 max-w-[488px] w-full max-h-[98vh] bg-white rounded-sm sm:max-h-[90%] sm:overflow-y-scroll",
              className
            )
          }>
            <div
              className="absolute right-4 top-4 cursor-pointer hover:opacity-50 z-50 duration-150 ease-in"
              onClick={onClose}
            >
              <CloseIcon stroke={"black"} />
            </div>
            <p className="text-[20px] leading-[30px] font-medium text-black mb-6">{title}</p>
            {children}
          </div>
        </div>
      </div>
    </Dialog>
  )
};

export default ModalRequest;
